import Grid from '@mui/material/Unstable_Grid2/Grid2'
import AvatarOne from '../../../../Components/AvatarOne/AvatarOne'
import { Tooltip, Typography } from '@mui/material'
import { Cancel, Edit, Place } from '@mui/icons-material'
import { VisitantesContext } from '../../../../Providers/VisitantesContext/VisitantesContext'
import { useContext } from 'react'

const CardVisitanteSelecionado = ({ pessoa, modifyDisabled }) => {
    const {
        removeVisitanteSelecionado,
        activeCond,
        buscarInfoVisitante,
        localizacaoImoveis,
        enviaLocalizacao
    } = useContext(VisitantesContext)

    return (
        <Grid sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '130px',
            height: '130px',
            // border: '1px solid white',
            margin: '5px',
            borderRadius: '5px',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '5px',
            position: 'relative'
        }}>
            <Grid sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%'
            }}>
                <Grid xs={3}>
                </Grid>
                <Grid xs={6}>
                    <AvatarOne height={'60px'} width={'60px'} src={`${window.location.origin.replace(':3003', '')}/wsOnePortaria/web/images/${activeCond.id_central}/f${pessoa.CD_ACESSO}.jpg?${new Date().getTime()}`}/>
                </Grid>
                <Grid xs={3} sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end'
                }}>
                    {localizacaoImoveis.length > 0 &&
                        <Tooltip title="Enviar localização do imóvel para o visitante" placement="top" arrow>
                            <Place sx={{ fontSize: '25px', color: '#028f0e', cursor: 'pointer' }} onClick={() => { enviaLocalizacao(pessoa) }} />
                        </Tooltip>
                    }
                </Grid>
                <div style={{ position: 'absolute', top: 0, right: 17 }}>
                    <Cancel titleAccess={"Remover visitante"} onClick={() => { removeVisitanteSelecionado(pessoa.CD_ACESSO); modifyDisabled(true) }} cursor="pointer" color="error" />
                </div>
                <div style={{ position: 'absolute', top: 0, left: 17 }}>
                    <Edit titleAccess={"Editar visitante"} onClick={() => { buscarInfoVisitante(pessoa.CD_ACESSO) }} cursor="pointer" style={{
                        color: 'black'
                    }} />
                </div>
            </Grid>
            <Typography titleAccess={pessoa.nome} sx={{ ...TypographySx, fontWeight: '500' }}>
                {pessoa.nome}
            </Typography>
        </Grid>
    )
}

export default CardVisitanteSelecionado

const TypographySx = {
    color: 'black',
    fontSize: '11px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '100%',
    textAlign: 'center',
    paddingLeft: '5px',
    paddingRight: '5px',
    boxSizing: 'border-box'
}
